import React from 'react'

const defaultBlocks = [
  {
    title: 'Centralize feedback from every channel',
    description:
      'Collect complaints and commendations from Web, USSD, and WhatsApp in one organized dashboard.',
    ctaLabel: 'Explore dashboards',
    ctaHref: 'https://app.clientshot.com/sign-up',
    image: {
      src: '',
      alt: 'Feature preview',
    },
  },
  {
    title: 'Turn complaints into structured action',
    description:
      'Track every issue from submission to resolution with clear ownership and status updates.',
    ctaLabel: 'Manage complaints',
    ctaHref: 'https://app.clientshot.com/sign-up',
    image: {
      src: '',
      alt: 'Feature preview',
    },
  },
  {
    title: 'Recognize and amplify positive feedback',
    description:
      'Highlight commendations, reward top-performing teams, and strengthen morale across your organization.',
    ctaLabel: 'Track commendations',
    ctaHref: 'https://app.clientshot.com/sign-up',
    image: {
      src: '',
      alt: 'Feature preview',
    },
  },
  {
    title: 'Gain real-time visibility into customer sentiment',
    description:
      'See trends, recurring issues, and satisfaction patterns as feedback comes in.',
    ctaLabel: 'Analyze feedback',
    ctaHref: 'https://app.clientshot.com/sign-up',
    image: {
      src: '',
      alt: 'Feature preview',
    },
  },
]

const FeaturesBlocks = ({ content = [] }) => {
  const blocks = content.length ? content : defaultBlocks

  return (
    <div>
        <section className="relative  py-20 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-24">
        {blocks.map((block, index) => {
          const reverse = index % 2 === 1

          return (
            <div key={index} className="grid lg:grid-cols-2 gap-12 items-center">
              {!reverse && (
                <div data-aos="fade-right" className="space-y-6">
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
                    {block.title}
                  </h2>

                  <p className="text-gray-600 text-lg max-w-xl">
                    {block.description}
                  </p>

                  <a href={block.ctaHref} className="btn btn-primary px-6 py-3 rounded-xl w-max text-white font-medium shadow-md hover:opacity-90 transition">
                    {block.ctaLabel}
                  </a>
                </div>
              )}

              <div
                data-aos={reverse ? 'fade-right' : 'fade-left'}
                className={`${reverse ? 'order-1 lg:order-none' : ''} w-full h-[260px] sm:h-[320px] lg:h-[380px] rounded-3xl overflow-hidden`}
              >
                {block.image?.src ? (
                  <img src={block.image.src} alt={block.image.alt || 'Feature preview'} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gray-200" />
                )}
              </div>

              {reverse && (
                <div
                  data-aos="fade-left"
                  className="order-2 lg:order-none space-y-6"
                >
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
                    {block.title}
                  </h2>

                  <p className="text-gray-600 text-lg max-w-xl">
                    {block.description}
                  </p>

                  <a href={block.ctaHref} className="btn btn-primary px-6 py-3 rounded-xl w-max text-white font-medium shadow-md hover:opacity-90 transition">
                    {block.ctaLabel}
                  </a>
                </div>
              )}
            </div>
          )
        })}

      </div>
    </section>
    </div>
  )
}

export default FeaturesBlocks
